<script setup>
// Badge(s) de funil/etapa de uma conversa. Usado na LISTA de conversas (pill
// compacto) e na LATERAL da conversa (com nome do funil). Fonte: useKanbanFunnels.
import { computed } from 'vue';
import { useKanbanFunnels } from 'dashboard/composables/useKanbanFunnels';

const props = defineProps({
  conversation: { type: Object, required: true },
  // 'list' = pill compacto (só bolinha + etapa); 'panel' = com o nome do funil.
  variant: { type: String, default: 'list' },
});

const { funnelsForConversation } = useKanbanFunnels();
const badges = computed(() => funnelsForConversation(props.conversation));
</script>

<template>
  <div v-if="badges.length" class="flex flex-wrap items-center gap-1">
    <span
      v-for="b in badges"
      :key="b.funnelKey"
      v-tooltip.top="`${b.funnelName}: ${b.stage}`"
      class="inline-flex items-center gap-1 rounded-md bg-n-alpha-2 max-w-full leading-4"
      :class="variant === 'panel' ? 'px-2 py-1 text-sm' : 'px-1.5 py-0.5 text-xxs'"
    >
      <span
        class="rounded-full flex-shrink-0"
        :class="[b.dotClass, variant === 'panel' ? 'size-2' : 'size-1.5']"
      />
      <span v-if="variant === 'panel'" class="text-n-slate-11 flex-shrink-0">
        {{ b.funnelName }}:
      </span>
      <span class="truncate font-medium text-n-slate-12">{{ b.stage }}</span>
    </span>
  </div>
</template>
